module.exports = __webpack_public_path__ + "static/media/bcpt.af11612c.svg";